import { render, staticRenderFns } from "./WorkflowReportsPage.vue?vue&type=template&id=5c4baa53&scoped=true"
import script from "./WorkflowReportsPage.vue?vue&type=script&lang=js"
export * from "./WorkflowReportsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4baa53",
  null
  
)

export default component.exports